// import request from '@/utils/request'
import axios from 'axios'
import global from '@/global/variable.js'


// 获取供应商列表
export function getList(data) {
  const url = global.requestUrl + '/supplier/list?limit=' + data.limit + '&page=' + data.page
  return axios.get(url)
}

// 创建供应商信息
export function createOne(data) {
  const url = global.requestUrl + '/supplier/create'
  return axios.post(url, data)
}

// 更新供应商信息
export function updateOne(data) {
  const url = global.requestUrl + '/supplier/update'
  return axios.post(url, data)
}

// 删除供应商信息
export function deleteOne(data) {
  const url = global.requestUrl + '/supplier/delete/' + data.id
  return axios.get(url)
}

// 创建人员预约信息
export function createManOrderInfo(data) {
  const url = global.requestUrl + '/personOrder/create'
  return axios.post(url, data, {headers: {
    'Content-Type':'multipart/form-data'
  }})
}

// 获取预约列表
export function getManOrderList(data) {
  const url = global.requestUrl + '/personOrder/list?limit=' + data.limit + '&page=' + data.page + '&startDate=' + data.start + '&endDate=' + data.end + '&name=' + data.name
  return axios.get(url)
}

// 人员预约审核
export function updateManOrderStatus(data) {
  const url = global.requestUrl + '/personOrder/check/' + data.id + '?yesOrNo=' + data.yesOrNo + '&rejectReason=' + data.rejectReason
  return axios.get(url)
}

// 创建货车预约信息
export function createTruckOrderInfo(data) {
  const url = global.requestUrl + '/truckOrder/create'
  return axios.post(url, data)
}

// 获取预约列表
export function getTruckOrderList(data) {
  const url = global.requestUrl + '/truckOrder/list?limit=' + data.limit + '&page=' + data.page + '&startDate=' + data.start + '&endDate=' + data.end + '&name=' + data.name
  return axios.get(url)
}

// 货车预约审核
export function updateTruckOrderStatus(data) {
  const url = global.requestUrl + '/truckOrder/check/' + data.id + '?yesOrNo=' + data.yesOrNo + '&rejectReason=' + data.rejectReason
  return axios.get(url)
}

// 删除预约信息
export function deleteOrderInfo(data) {
  const url = global.requestUrl + '/truckOrder/delete/' + data.id
  return axios.get(url)
}

// 获取预约列表
export function getOrderList(data) {
  const url = global.requestUrl + '/truckOrder/history?limit=' + data.limit + '&page=' + data.page
  return axios.get(url)
}

// 获取访问列表
export function getAccessList(data) {
  const url = global.requestUrl + '/truckAccess/history?limit=' + data.limit + '&page=' + data.page
  return axios.get(url)
}

// 获取过磅列表
export function getWeighBridgeList(data) {
  const url = global.requestUrl + '/weighbridge/history?limit=' + data.limit + '&page=' + data.page
  return axios.get(url)
}

// 获取灌料列表
export function getMaterialCheckList(data) {
  const url = global.requestUrl + '/dualCheck/history?limit=' + data.limit + '&page=' + data.page
  return axios.get(url)
}


// 获取消息推送列表
export function getProjectConfigList(data) {
  const url = global.requestUrl + '/projectConfig/list'
  return axios.get(url)
}

// 获取货车道闸列表
export function getAggregateTruckStay(data) {
  const url = global.requestUrl + '/truckAccess/exitCar'
  return axios.get(url)
}
